import * as Preact from "preact"
import { useState } from "preact/hooks"
import Pointer from "poin"
import Joyp from "joyp"
import prettyms from "pretty-ms"

import App from "@fae/source/models/App.js"
import Dev from "@fae/source/models/dev/Dev.js"
import Navigation from "@fae/source/engine/navigating/Navigation.js"
import StageModel from "@fae/source/models/Stage.js"

import "@fae/source/views/Mount.less"
import Stage from "@fae/source/views/Stage.jsx"
import ChapterUI from "@fae/source/views/ChapterUI.jsx"
import Frame from "@fae/source/views/components/Frame.jsx"
import UnitSprite from "@fae/source/views/components/UnitSprite.jsx"
import Snow from "@fae/source/views/components/Snow.jsx"
import ModalUI from "@fae/source/views/ModalUI.jsx"
import PauseMenu from "@fae/source/views/components/PauseMenu.jsx"
import TitleSplashScreen from "@fae/source/views/components/TitleSplashScreen.jsx"

import DevPanes from "@fae/source/views/dev/panes/DevPanes.jsx"
import DevScreens from "@fae/source/views/dev/screens/DevScreens.jsx"
import DevEncounterEditorScreen from "@fae/source/views/dev/editorscreens/DevEncounterEditorScreen.jsx"
import DevBattleEditorScreen from "@fae/source/views/dev/editorscreens/DevBattleEditorScreen.jsx"
import DevScriptEditorScreen from "@fae/source/views/dev/editorscreens/DevScriptEditorScreen.jsx"

import Audiomix from "@fae/source/engine/Audiomix.js"
import Testlaunch from "@fae/source/engine/testing/utility/Testlaunch.js"

import tests from "@fae/source/data/tests.js"
import test from "@fae/source/engine/testing/test.js"
import audios from "@fae/source/data/audios.js"
import savetests from "@fae/source/data/games/savetests.js"
import preload from "@fae/source/data/preload.js"
import games from "@fae/source/data/games"


export default class Mount {
    render() {
        return (
            <div class="Mount" id="root"
                isDev={Dev.areDevPanelsOpen || false}
                isInProtoMode={Dev.inProtoMode || false}
                gamekey={App.game?.key}
                pixelated={App.game?.configuration?.pixelated}>
                <DevPanes>
                    <div class="FrameSection">
                        <PreloadedImages/>
                        <Screen/>
                    </div>
                </DevPanes>
            </div>
        )
    }

    componentDidMount() {
        const element = document.getElementById("root")
        Pointer.listen(element)
        // IS THIS SAFE TO BE HERE? NOT IN FRAME? WHICH IS NOW EXCLUSIVELY A VIEW PORT NOT AN EVENT LISTENER
    }
    onContextMenu(event) {
        event.preventDefault()
    }
}

class PreloadedImages {
    render() {
        return (
            <div class="PreloadedImages">
                {Object.keys(preload.images).map((image) => {
                    return (
                        <img src={image}/>
                    )
                })}
            </div>
        )
    }
}

class Screen {
    render() {
        let Screen = undefined
        const screenKey = Navigation?.state?.screenKey
        if(screenKey != undefined) {
            Screen = SCREENS[screenKey]
            if(App?.game?.screens != undefined
            && App?.game?.screens[screenKey] != undefined) {
                Screen = App.game.screens[screenKey]
            }
        }

        if(Screen != undefined) {
            return <Screen/>
        }

        return (
            <BlankScreen/>
        )

        // return (
        //     <ErrorScreen message={"Could not find screen: " + screenKey}/>
        // )
    }
}

function ErrorScreen({message}) {
    return (
        <Frame>
            <div class="ErrorScreen">
                <title>Faerie Fire</title>
                {Navigation?.state?.message || message || "Something went wrong."}
            </div>
        </Frame>
    )
}

function LoadingScreen() {
    return (
        <Frame>
            <div class="LoadingScreen">
                <div class="ProgressBar" style={{"width": (preload.loadedCount / preload.totalCount) * 100 + "%"}}/>
                <div class="Header Text">Loading...</div>
                <div class="Base Text">Loading...</div>
            </div>
        </Frame>
    )
}

function BlankScreen() {
    return (
        <Frame>
            <div class="BlankScreen"/>
        </Frame>
    )
}

const SCREENS = {
    "ErrorScreen": ErrorScreen,
    "LoadingScreen": LoadingScreen,
    "TitleScreen": function() {
        const game = games[Navigation.state.gameSlug]
        if(game == undefined) return
        if(Joyp.wasJustPressed(0, "start-button")) {
            if(Navigation.state.isSplashing !== false) {
                Navigation.state.isSplashing = false
            } else {
                Navigation.go("/games/" + game.key + "/chapters/" + (game.firstChapterKey ?? "1"))
            }
        }

        var savegame
        try {
            savegame = JSON.parse(localStorage.getItem(game.key + "_savegame"))
        } catch (e) {
            savegame = undefined
        }

        let loadButton = (
            <div class="Button" isDead="true">Load Game</div>
        )
        if(savegame != undefined) {
            loadButton = (
                <div class="Button" onClick={() => Navigation.go("/games/" + game.key + "/reload")}>Load Game</div>
            )
        }

        function onClick() {
            if(game.openingEvents != undefined) {
                App.load({"game": {...game}})
                App.sequence = {}
                App.sequence.steps = StageModel.processEventSteps({}, game.openingEvents())
            } else {
                Navigation.go("/games/" + game.key + "/chapters/" + (game.firstChapterKey ?? "1"))
            }
        }

        return (
            <Frame>
                <TitleSplashScreen>
                    <div class="Default TitleContents">
                        <div class="Title">{game.title || game.key}</div>
                        <div class="Subtitle">{game.subtitle}</div>
                        <div class="Button" onClick={onClick}>Play</div>
                        <div class="Button" onClick={() => window.nativeAPI?.quit()}>Quit</div>
                    </div>
                </TitleSplashScreen>
            </Frame>
        )
    },
    "PartyScreen": function() {
        if(App.game == undefined) return
        if(App.game.player == undefined) return
        let stage = App.getActiveStage()
        return (
            <Frame>
                <div class="PartyScreen">
                    <div class="UnitSection">
                        <div class="UnitList">
                            {Object.values(App.game.player.units).map((unit) => {
                                return (
                                    <div class="UnitStub" onClick={() => Navigation.state.selectedUnitKey = unit.key}>
                                        <div class="Letter">{unit.name.charAt(0)}</div>
                                    </div>
                                )
                            })}
                        </div>
                        {Navigation.state.selectedUnitKey != undefined && App.game.player.units[Navigation.state.selectedUnitKey] != undefined && (
                            <div class="SelectedUnit">
                                <div class="Name">
                                    {App.game.player.units[Navigation.state.selectedUnitKey].name}
                                </div>
                                <div class="Items">
                                    <div class="Item">
                                        {App.game.player.units[Navigation.state.selectedUnitKey].items[0]?.name}
                                    </div>
                                    <div class="Item">
                                        {App.game.player.units[Navigation.state.selectedUnitKey].items[1]?.name}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div class="ItemSection">
                        {Object.values(App.game.player.inventory.items).map((item) => {
                            return (
                                <div class="ItemStub" onClick={() => {
                                    if(Navigation.state.selectedUnitKey == undefined) return
                                    App.game.player.units[Navigation.state.selectedUnitKey].items[1] = item
                                }}>
                                    {item.name}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </Frame>
        )
    },
    "OverworldScreen": function() {
        if(App.game == undefined) return
        let stage = App.getActiveStage()

        let overworld = App.game.overworld
        if(App.game.overworlds != undefined
        && App.game.overworlds[Navigation.state.overworldKey] != undefined) {
            overworld = App.game.overworlds[Navigation.state.overworldKey]
        }
        if(overworld == undefined) return

        // let image = overworld.image
        // if(overworld.image instanceof Function) {
        //     image = overworld.image()
        // }
        // {image && <img class="Map" src={image}/>}
        return (
            <Frame>
                <div class="OverworldScreen">
                    {overworld.images && overworld.images.map((image) => {
                        if(image instanceof Function) image = image()
                        if(image == undefined) return
                        return (
                            <div class="Image" style={{
                                "background-image": "url(" + (image.url || image) + ")",
                                "background-size": image.size,
                                "background-color": image.color,
                                "background-position": image.position,
                                "mix-blend-mode": image.blendmode,
                                "opacity": image.opacity,
                            }}/>
                        )
                    })}
                    <div class="Prompt">{overworld.prompt instanceof Function ? overworld.prompt() : overworld.prompt}</div>
                    <ModalUI stage={stage}/>
                    {overworld.locations && Object.values(overworld.locations).map((location) => {
                        return (
                            <div class="Location" key={location.key}
                                onClick={() => {
                                    if((location.isReachable instanceof Function ? location.isReachable() == true : location.isReachable == true)
                                    && location.isFinished != true) {
                                        Navigation.go("/games/" + App.game.key + "/chapters/" + location.chapterKey)
                                    }
                                }}
                                style={{
                                    "left": location?.position?.x + "em", "top": location?.position?.y + "em",
                                    "background-image": location.puck && "url(" + location.puck + ")",
                                    "background-size": "50%",
                                }}
                                isDisplayed={location.isDisplayed instanceof Function ? location.isDisplayed() : location.isDisplayed}
                                // isDisplayedAsEventualRoute={location.isDisplayedAsEventualRoute}
                                isReachable={location.isReachable instanceof Function ? location.isReachable() : location.isReachable}
                                isFinished={location.isFinished}>
                                {location.icon && <div class="Icon" style={{
                                    "background-image": "url(" + location.icon + ")"
                                }}/>}
                                <div class="Text">
                                    <span class="Title">{location.title}</span>
                                    <br/>
                                    <span class="Subtitle">{location.subtitle instanceof Function ? location.subtitle() : location.subtitle}</span>
                                </div>
                            </div>
                        )
                    })}
                    {overworld?.player?.position && (
                        <div class="Player" style={{
                            "left": overworld.player.position.x + "em",
                            "top": overworld.player.position.y + "em",
                        }}/>
                    )}
                    {overworld.routes && Object.keys(overworld.routes).map((routeKey) => {
                        const route = overworld.routes[routeKey]
                        return (
                            <div class="Route" key={routeKey}
                                style={{"left": route?.x + "em", "top": route?.y + "em"}}
                                isReachable={route.isReachable} isDisplayed={route.isDisplayed}/>
                        )
                    })}
                </div>
            </Frame>
        )
    },
    "MissionScreen": function() {
        const [selectedFilter, setSelectedFilter] = useState("ALL");
        if(App.game == undefined) return
        if(App.game.overworld == undefined) return
        if(App.game.overworld.locations == undefined) return
        let stage = App.getActiveStage()
        const selectedMission = App.game.overworld.locations[App.game.overworld.selectedLocationKey]
        return (
            <div class="MissionScreen">
                <ModalUI stage={stage}/>
                <div class="MissionsList">
                    <div class="MailClient">
                        &#128236; H.E.L.L.-o Employee Mail
                    </div>
                    <div class="Filters">
                        <div class={selectedFilter === "ALL" ? "SelectedFilter" : ""} onClick={() => setSelectedFilter("ALL")}>
                            All
                        </div>
                        <div class={selectedFilter === "UNREAD" ? "SelectedFilter" : ""} onClick={() => setSelectedFilter("UNREAD")}>
                            Unread
                        </div>
                    </div>
                    {Object.values(App.game.overworld.locations)
                        .filter((location) => selectedFilter === "ALL" || selectedFilter === "UNREAD" && !location.isFinished)
                        .map((location) => {
                            return (
                                <div class="Mission" key={location.key} onClick={() => {if(location.isReachable) App.game.overworld.selectedLocationKey = location.key}}
                                    isDisplayed={location.isDisplayed} isReachable={location.isReachable} isFinished={location.isFinished} isSelected={location.key == selectedMission?.key}>
                                    <img class="CompanyLogo" src={require("@fae/source/assets/images/book-tactics/logo.png")}/>
                                    <div class="EmailInfo">
                                        <div class="Sender">Household Entity Liquidator and Liberator, LLC HR</div>
                                        <div class="Title">{location.title}</div>
                                    </div>
                                    <div>
                                        <div class="Date">
                                            May 3
                                        </div>
                                        {!location.isFinished && (
                                            <div class="Important">!</div>
                                        )}
                                    </div>
                                </div>
                            )
                    })}
                </div>
                <div class="SelectedMission" isFinished={location.isFinished}>
                    {!!selectedMission && [
                        <div class="Details">
                            <div class="EmailHeader">
                                <img class="CompanyLogo" src={require("@fae/source/assets/images/book-tactics/logo.png")}/>
                                <div class="EmailInfo">
                                    <div class="SenderAndDate">
                                        <div class="Sender">Household Entity Liquidator and Liberator, LLC HR</div>
                                        <div class="Date">May 3, 2015</div>
                                    </div>
                                    <div class="Title">{selectedMission.title}</div>
                                </div>
                            </div>
                            <div class="Subtitle">
                                <span class="Number">Mission {selectedMission.key}</span>
                                <span> / </span>
                                <span class="Byline">{selectedMission.isFinished ? selectedMission.byline || "???" : "Unknown Entity"}</span>
                            </div>
                            {selectedMission.briefing.map((brief) => (
                                <p class="Briefing">{brief}</p>
                            ))}
                        </div>,
                        <div class="Commands">
                            <div class="GoButton" onClick={() => {if(selectedMission.isReachable) Navigation.go("/games/" + App.game.slug + "/chapters/" + selectedMission.chapterKey)}}>
                                Go!!
                            </div>
                        </div>
                    ]}
                </div>
            </div>
        )
    },
    "ChapterScreen": function() {
        if(App.game == undefined) return
        if(preload.isLoading) {
            let Screen = LoadingScreen
            if(App?.game?.screens != undefined
            && App?.game?.screens["LoadingScreen"]) {
                Screen = App.game.screens["LoadingScreen"]
            }
            return <Screen/>
        }
        let stage = App.getActiveStage()
        if(Dev.inProtoMode == true) {
            if(Dev.mode == "battle") {
                return EDITOR_SCREENS["DevBattleEditorScreen"]()
            } else if(Dev.mode == "geography") {
                return EDITOR_SCREENS["DevGeographyEditorScreen"]()
            } else if(Dev.mode == "scripts") {
                return EDITOR_SCREENS["DevScriptEditorScreen"]()
            }
        }
        return (
            <Frame>
                <div class="ChapterScreen"
                    onMouseDown={(event) => event.button == 0 && App.game.chapter.selection.start()}
                    onMouseUp={(event) => event.button == 0 && App.game.chapter.selection.finish()}
                    onDblClick={(event) => {App.game.chapter.selection.doubleStart()}}
                    onContextMenu={(event) => App.game.chapter.selection.cancel()}>
                    <title>{games[App.game.key].title}</title>
                    <Stage stage={stage}/>
                    <ChapterUI stage={stage}/>
                    <ModalUI stage={stage}/>
                    <PauseMenu/>
                </div>
            </Frame>
        )
        // <Snow stage={stage}/>
    },
    "CreditsScreen": function() {
        return (
            <Frame>
                <div class="CreditsScreen" gameSlug={Navigation.state.gameSlug}>
                    <div class="Content">
                        <div class="Title">
                            {games[Navigation.state.gameSlug]?.image ? <img src={games[Navigation.state.gameSlug]?.image}/> : <span>{games[Navigation.state.gameSlug]?.title}</span>}
                        </div>
                        {games[Navigation.state.gameSlug]?.credits && <div class="Credits">
                            <div class="Header">A goodberry game by:</div>
                            <div class="Contributors">
                                {games[Navigation.state.gameSlug]?.credits.map((credit, index) => {
                                    if(index % 3 == 0) {
                                        return (
                                            <div class="ContributorsLine">
                                                {[0, 1, 2].map((subindex) => {
                                                    const credit = games[Navigation.state.gameSlug]?.credits[index + subindex]
                                                    if(credit == undefined) return
                                                    return (
                                                        <div class="Contributor">
                                                            <div class="Sprite" style={{"background-image": "url(" + credit.sprite + ")"}}/>
                                                            <small class="Name" style={{"background-color": credit.color}}>{credit.name}</small>
                                                            <small class="Position" style={{"background-color": credit.color}}>{credit.position}</small>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )
                                    }
                                })}
                            </div>
                        </div>}
                        {games[Navigation.state.gameSlug]?.thanks && <div class="SpecialThanks">
                            <div class="Header">Special Thanks</div>
                            {games[Navigation.state.gameSlug]?.thanks.map((name) => (
                                <div class="Name">
                                    {name}
                                </div>
                            ))}
                        </div>}
                        <div class="CallToAction">
                            <div class="Header">
                                <span>Keep up to date:<br/>Subscribe to our email list</span>
                            </div>
                            <form action="https://games.us13.list-manage.com/subscribe/post?u=2107e75aa44205e6387eb52d5&amp;id=0facb46663&amp;f_id=002760e1f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_self" novalidate="">
                                <div class="BoxButNotThatBox">
                                    <label for="mce-EMAIL">Email Address</label>
                                    <div class="Inputs">
                                        <input type="email" name="EMAIL" class="required email" id="mce-EMAIL" required=""/>
                                        <input type="submit"/>
                                    </div>
                                </div>
                                <div aria-hidden="true" style="position: absolute; left: -5000px;">
                                    <input type="text" name="b_2107e75aa44205e6387eb52d5_0facb46663" tabindex="-1" value=""/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Frame>
        )
        // <div class="FinalScreen">
        //     <div class="Thanks" onMouseDown={() => Navigation.go("/games/" + App.game.key + "/title")}>
        //         Thanks for playing!!
        //     </div>
        // </div>
        // return (
        //     <div class="CreditsScreen">
        //         <div class="Content">
        //             <div class="Title">
        //                 <span>This Be Mutiny</span>
        //             </div>
        //             <div class="Credits">
        //                 <div>A goodberry game by</div>
        //                 <div>Andrew Goodenough</div>
        //                 <div>Doc McPherson</div>
        //                 <div>Anna Arkhipova</div>
        //                 <div>Vitor Amado</div>
        //                 <div>So many artists</div>
        //             </div>
        //             <div class="Thanks" onMouseDown={() => Navigation.go("/games/dungeon")}>
        //                 Thanks for playing!!
        //             </div>
        //         </div>
        //     </div>
        // )
    },
    ...DevScreens,
}

const EDITOR_SCREENS = {
    "DevGeographyEditorScreen": function() {
        return <DevEncounterEditorScreen/>
    },
    "DevBattleEditorScreen": function() {
        return <DevBattleEditorScreen/>
    },
    "DevScriptEditorScreen": function() {
        return <DevScriptEditorScreen/>
    },
}
